import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowMove = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	width: 24,
	height: 24,
	strokeWidth: 1.5,
	"data-darkreader-inline-stroke": "",
	style: { "--darkreader-inline-stroke": "currentColor" },
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M18 9l3 3l-3 3" }),
		/* @__PURE__ */ _jsx("path", { d: "M15 12h6" }),
		/* @__PURE__ */ _jsx("path", { d: "M6 9l-3 3l3 3" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 12h6" }),
		/* @__PURE__ */ _jsx("path", { d: "M9 18l3 3l3 -3" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 15v6" }),
		/* @__PURE__ */ _jsx("path", { d: "M15 6l-3 -3l-3 3" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 3v6" })
	]
});
const ForwardRef = forwardRef(SvgArrowMove);
export default ForwardRef;
